import { Grid } from '@mui/material'
import { Outlet, useLocation, useOutlet } from 'react-router-dom'
import { useMemo } from 'react'
import AppsHeader from '../components/AppsHeader'

function AppsLayout() {

    console.log('apps layout')
    const u = useOutlet()


    console.log(u)
    const location = useLocation()

    const pageTitle = useMemo(() => {
        if (location.pathname.includes('contract')) {
            return 'قرارداد دیجیتال'
        }
        if (location.pathname.includes('pki')) {
            return 'امضا دیجیتال'
        }
        if (location.pathname.includes('identity')) {
            return 'احراز هویت'
        }
        if (location.pathname.includes('safte')) {
            return 'سفته الکترونیک'
        }
        return ''
    }, [])

    return <Grid container>
        <AppsHeader title={pageTitle} />
        <Outlet />
    </Grid>

}

export default AppsLayout;
